import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { settingsActions } from "../actions/settings.actions";
import { tap, map } from "rxjs";
import { defaultSettings } from "../reducers/settings.reducers";
import moment from "moment";

@Injectable()
export class SettingsEffects {

    constructor(
        private actions$: Actions,
    ) { }

    persistSettings$ = createEffect(() => this.actions$.pipe(
        ofType(settingsActions.saveSettings),
        tap(({ settings }) => {
            const merged = { ...defaultSettings, ...settings };
            localStorage.setItem('appSettings', JSON.stringify(merged));
        })
    ), { dispatch: false });

    loadSettings$ = createEffect(() => this.actions$.pipe(
        ofType(settingsActions.loadSettings),
        map(() => {
            const stored = localStorage.getItem('appSettings');
            const parsed = stored ? JSON.parse(stored) : defaultSettings;
            return settingsActions.loadSettingsSuccess({ settings: { ...defaultSettings, ...parsed } });
        })
    ));

    setMomentLocale$ = createEffect(() => this.actions$.pipe(
        ofType(settingsActions.loadSettingsSuccess, settingsActions.saveSettings),
        tap(({ settings }) => {
            const momentLocale = settings.localeKey.split('_')[0];

            moment.updateLocale(momentLocale, {
                week: settings.isoWeek
                    ? { dow: 1, doy: 4 }
                    : { dow: 0, doy: 6 }
            });

            moment.locale(momentLocale);

            const currentDateFormat = settings.dateFormat;
            const currentTimeFormat = settings.timeFormat;

            moment.defaultFormat = `${currentDateFormat} ${currentTimeFormat}`;

        })
    ), { dispatch: false });
}
